import { render, staticRenderFns } from "./AdmissionClinical.vue?vue&type=template&id=1d2a0b64&"
import script from "./AdmissionClinical.vue?vue&type=script&lang=js&"
export * from "./AdmissionClinical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports